<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14BIc80/tc-custom/9781460382714.jpg?1697043251427" alt="This image is the cover for the book What the Prince Wants"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What the Prince Wants
      </h1>
      <p class="bookDescription body article font2">
        <p>What happens when a royal daddy falls for his child's live-in nanny? <br/><br/>Widowed Prince Mikos Colin Alexander wants to raise his little girl out of the spotlight. Granted a six-month leave from his royal duties, he escapes to Los Angeles, posing as a regular guy, one in need of a live-in nanny. Colin reluctantly hires Darcy Cooper, the curvy beauty who easily wins over his baby duchess. But soon the lush, love-shy American wins him over, too. Now he's torn between duty to the crown and what feels like his newfound family. But when Darcy discovers her emotionally distant boss is royalty, will all bets be off?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jules Bennett
      </h2>
      
      <p class="authorDescription body article"><I>USA&#160;TODAY</I> Bestselling Author Jules Bennett has penned&#160;more than&#160;50 novels during her short career.&#160;She&#39;s married to her high school sweetheart, has two active girls, and is a former salon owner. Jules can be found on Twitter, Facebook (Fan Page), and her website julesbennett.com. She holds contests via these three outlets with each release and loves to hear from readers!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4956ee05